var React = require('react');

function BrowserBar (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#F1F5FB","d":"M0 0h816v47H0z","key":0}),React.createElement("path",{"fill":"#fff","d":"M108 10h690v27H108z","key":1}),React.createElement("ellipse",{"cx":"28.021","cy":"23.5","rx":"10.021","ry":"9.5","fill":"#FFA5A5","key":2}),React.createElement("ellipse",{"cx":"54","cy":"23.5","rx":"10.021","ry":"9.5","fill":"#FFE4A5","key":3}),React.createElement("ellipse",{"cx":"79.98","cy":"23.5","rx":"10.021","ry":"9.5","fill":"#BEFFA5","key":4})]);
}

BrowserBar.defaultProps = {"viewBox":"0 0 816 47","fill":"none"};

module.exports = BrowserBar;

BrowserBar.default = BrowserBar;
